import { makeAutoObservable } from 'mobx'

import type Service from '@src/service'
import type {
  OntologyCreateInput,
  OntologyEnhanceRequest,
  OntologyUpdateInput,
} from '@src/service/transport/AiClient'

import AutomationsStore from './AutomationsStore'

export default class AiStore {
  automations: AutomationsStore
  constructor(private root: Service) {
    this.automations = new AutomationsStore(
      root.storage,
      root.transport,
      root.workflow,
      root.analytics,
    )
    makeAutoObservable(
      this,
      {},
      {
        autoBind: true,
      },
    )
  }

  togglePrompt(promptId: string, isActive: boolean) {
    return this.root.transport.ai.prompt.toggle(promptId, isActive)
  }

  getPromptSettings(phoneNumberId: string) {
    return this.root.transport.ai.prompt.get(phoneNumberId)
  }

  importWebsite(websiteUrl: string) {
    return this.root.transport.ai.website.import(websiteUrl)
  }

  getWebsiteSource(websiteUrl: string) {
    return this.root.transport.ai.website.getWebsiteSource(websiteUrl)
  }

  getOntology() {
    return this.root.transport.ai.ontology.get()
  }
  importOntologyFromWebsite(websiteUrl: string) {
    return this.root.transport.ai.ontology.importFromWebsite({ websiteUrl })
  }

  createOntology(input: OntologyCreateInput) {
    return this.root.transport.ai.ontology.create(input)
  }

  updateOntology(input: OntologyUpdateInput) {
    return this.root.transport.ai.ontology.update(input)
  }

  deleteOntology() {
    return this.root.transport.ai.ontology.delete()
  }

  enhanceOntology(input: OntologyEnhanceRequest) {
    return this.root.transport.ai.ontology.enhance(input)
  }
}
